import { useState, useEffect, useCallback } from 'react'
import { Grid, Box } from '@mui/material'
import EmailFormVerification from '../emailVerificationSalesforce/emailverificationsalesforce'
import { verifyEmailAccess } from '../../utils/verifyEmailAccess/verifyEmailAccess'
import SectionOneForm from './minorPageOneES'
import SectionTwoForm from './minorPageTwoES'
import SectionThreeForm from './minorPageThreeES'
import SuccessPage from './minorPageFourES'
import { useNavigate, useParams } from 'react-router-dom'
import envConfig from '../../utils/configEnv/config'
import { Typography } from '@nwh-consumer-digital/nw-component-lib'
import { useProgress } from '../context/ProgressContext'

const formSubject = 'MyNorthwell minor proxy form request en español'
const pageTitle = 'Formulario Para Solicitar Acceso Como Apoderado – Menores (Menor De 13 Años)'
const formId = 'MinorProxyFormES'
const fmhFormType = 'Minor'
const instructionIntroduction = 'MyNorthwell Minor Request has Been Added to Sharepoint List'
const configBaseUrl = envConfig?.REACT_APP_LOGICAPPSHAREPOINTURL
const nwcypt = envConfig?.REACT_APP_NWCYPT
const DPXAppHeader = 'Bearer ' + envConfig?.REACT_APP_DPX_APPKEY

const iformHeaders = new Headers()
iformHeaders.append('Authorization', DPXAppHeader)
iformHeaders.append('Content-Type', 'application/json')

export default function minorProxyFormNoGig() {
  //UseProgress Context Hook
  const { updateProgress } = useProgress()

  let { id } = useParams()
  const navigate = useNavigate()

  const [showEmailForm, setShowEmailForm] = useState(true)
  const [showError, setShowError] = useState(false)
  const [showPageOne, setShowPageOne] = useState(false)
  const [showPageTwo, setShowPageTwo] = useState(false)
  const [showPageThree, setShowPageThree] = useState(false)
  const [showPageFourSuccess, setShowPageFourSuccess] = useState(false)
  const [postResult, setPostResult] = useState(null)

  useEffect(() => {
    document.title = pageTitle
    document.getElementById('pageTextHeader').innerHTML = pageTitle

    // Set Value For Progress
    updateProgress(10)

    if (id) {
      verifyEmailAccess(id).then((isVerified) => {
        if (isVerified) {
          setShowEmailForm(false)
          setShowPageOne(true)
        } else {
          setShowEmailForm(false)
          setShowPageOne(false)
          setShowError(true)
        }
      })
    } else {
      // console.log('no id');
    }
    scrollToTop()
  }, [id])

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  const postData = async (data) => {
    const formatDateString = (dateString) => {
      const [month, day, year] = dateString.split('/')
      return { month, day, year, formatted: `${month}-${day}-${year}` }
    }

    const patientDOB = formatDateString(data.sectionOneForm.DOBChild)
    const guardianDOB = formatDateString(data.sectionTwoForm.DOBGuardian)

    const postData = {
      firstName: data.sectionOneForm.firstName,
      lastName: data.sectionOneForm.lastName,
      mInitial: data.sectionOneForm.mInitial,
      date: patientDOB.formatted,
      dobMonth: patientDOB.month,
      dobDayofMonth: patientDOB.day,
      dobYear: patientDOB.year,
      gender: data.sectionOneForm.gender,
      streetNumber: data.sectionOneForm.streetNumber,
      City: data.sectionOneForm.City,
      State: data.sectionOneForm.State,
      Zip: data.sectionOneForm.Zip,
      relationshiptoPatient: data.sectionOneForm.relationshiptoPatient,
      firstNameGuardian: data.sectionTwoForm.firstNameGuardian,
      lastNameGuardian: data.sectionTwoForm.lastNameGuardian,
      mInitialGuardian: data.sectionTwoForm.mInitialGuardian,
      dobGuardian: guardianDOB.formatted,
      dobMonthGuardian: guardianDOB.month,
      dobDayofMonthGuardian: guardianDOB.day,
      dobYearGuardian: guardianDOB.year,
      streetNumberGuardian: data.sectionTwoForm.streetNumberGuardian,
      CityGuardian: data.sectionTwoForm.CityGuardian,
      StateGuardian: data.sectionTwoForm.StateGuardian,
      ZipGuardian: data.sectionTwoForm.ZipGuardian,
      phoneNumberGuardian: data.sectionTwoForm.phoneNumberGuardian,
      emailguardian: data.sectionTwoForm.emailguardian,
      uploadFile: data.sectionTwoForm.uploadFiles,
      signedImage: data.sectionThreeForm.imageUrl,
      signedImage: data.sectionThreeForm.imageUrl,
      isMultipleSignatures: false,
      signedImageTwo: '',
      accessKey: nwcypt,
      emailSubject: formSubject,
      timestamp: data.SectionTwoFormTimestamp,
      FormId: formId,
      instructionIntroduction,
    }

    try {
      const res = await fetch(configBaseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': 'token-value',
        },
        body: JSON.stringify(postData),
      })

      if (!res.ok) {
        navigate(`/Error/FMH Submission Error ${res.statusText}`)
        return
      }

      const data = await res.json()
      setPostResult({
        status: `${res.status}-${res.statusText}`,
        headers: {
          'Content-Type': res.headers.get('Content-Type'),
          'Content-Length': res.headers.get('Content-Length'),
        },
        data,
      })
    } catch (err) {
      setPostResult(err.message)
    }
  }

  const [ProxyFormObj] = useState({
    showPageThree: [],
    sectionOneForm: [],
    sectionTwoForm: [],
    SectionTwoFormTimestamp: '',
    showPageThreeSubmitted: false,
    sectionOneSubmitted: false,
    sectionTwoSubmitted: false,
    submitCompletedForm: false,
  })

  const formSubmission = useCallback(() => {
    if (ProxyFormObj.goBackLogin) {
      updateProgress(10)
      navigate('/')
    }

    if (ProxyFormObj.goBackPageOne) {
      setShowPageOne(true)
      setShowPageTwo(false)
      setShowPageThree(false)
      ProxyFormObj.sectionOneSubmitted = true
      ProxyFormObj.sectionTwoSubmitted = false
      ProxyFormObj.submitCompletedForm = false
      updateProgress(30)
      scrollToTop()
    }

    if (ProxyFormObj.goBackPageTwo) {
      setShowPageOne(false)
      setShowPageTwo(true)
      setShowPageThree(false)
      updateProgress(60)
      scrollToTop()
    }

    if (ProxyFormObj.goPageThree) {
      setShowPageOne(false)
      setShowPageTwo(false)
      setShowPageThree(true)
      updateProgress(80)
      scrollToTop()
    }

    if (ProxyFormObj.showPageThreeSubmitted) {
      setShowPageOne(true)
      setShowPageTwo(false)
      setShowPageThree(false)
      updateProgress(100)
      scrollToTop()
    }

    if (ProxyFormObj.submitCompletedForm) {
      setShowPageThree(false)
      postData(ProxyFormObj)
      updateProgress(100)
      scrollToTop()
      setShowPageFourSuccess(true)
    }
  }, [ProxyFormObj])

  return (
    <div id="PageTop">
      {showEmailForm && <EmailFormVerification formId={formId} fmhFormType={fmhFormType} locale={'ES'} />}
      {showPageOne && <SectionOneForm SubmissionState={ProxyFormObj} onFormStateChange={formSubmission} />}
      {showPageTwo && <SectionTwoForm SubmissionState={ProxyFormObj} onFormStateChange={formSubmission} />}
      {showPageThree && <SectionThreeForm SubmissionState={ProxyFormObj} onFormStateChange={formSubmission} />}
      {showPageFourSuccess && <SuccessPage />}
      {showError && (
        <Box className="pageContainer">
          <Grid container direction="column" justifyContent="space-between" alignItems="left">
            <Grid item>
              <Typography
                variant="h1"
                sx={{
                  marginTop: { xs: '1.25rem', sm: '1.25rem', md: '1.25rem', lg: '5rem', xl: '5rem' },
                  marginBottom: { xs: '2rem', sm: '2rem', md: '2rem', lg: '2rem', xl: '2rem' },
                }}>
                Error State
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  )
}
